<svelte:options tag={null} />

<script lang="ts">
  import { EventHandler } from '../../utilities/EventHandler';

  import type { SelectOption, SelectSize } from './select.types';

  export let id: string;
  export let valueselected = '';
  export let placeholder: string;
  export let size: SelectSize = 'm';
  export let isvalid = false;
  export let isinvalid = false;
  export let disabled = false;
  export let options: string;
  let eventHandler = new EventHandler();
  let valueSelected = '';

  $: parsedOptions = options ? (JSON.parse(options) as SelectOption[]) : [];
  $: valueSelected = valueselected;
  $: userClass = $$props.class;
  $: attributes = { ...$$restProps };
  $: delete attributes.class;
  function setClasses(
    isvalid: boolean,
    isinvalid: boolean,
    size: SelectSize,
  ): string {
    const classes = ['mc-select'];

    if (isvalid && !isinvalid) {
      classes.push('is-valid');
    }

    if (isinvalid) {
      classes.push('is-invalid');
    }
    if (size) {
      classes.push(`mc-select--${size}`);
    }

    return classes.join(' ');
  }
</script>

<!-- svelte-ignore a11y-no-onchange -->
<select
  {id}
  class="{setClasses(isvalid, isinvalid, size)} {userClass}"
  {disabled}
  bind:value={valueSelected}
  on:change={() => eventHandler.dispatch('change', valueSelected)}
  {...attributes}
>
  {#if placeholder}
    <option value="" disabled selected>
      -- {placeholder} --
    </option>
  {/if}

  {#each parsedOptions as opt (opt.id)}
    <option name={opt.value} disabled={opt.disabled} value={opt.value}>
      {opt.text}
    </option>
  {/each}
</select>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/_c.select';
</style>
